export const informationText = `
  display: flex;

  i {
    margin-right: 16px;
    font-size: 20px;
  }
`;